import { useQuery } from "@tanstack/react-query";

import { getSoilSightFieldSoil } from "services";

import { useIsAuthenticated } from "utils";

import { GET_SOIL_SIGHT_FIELD_SOIL } from "consts";

import { SoilSightFieldSoil } from "models";

/** Keyed by field and model version: a reselect or a version switch keeps the project id. */
export const useGetSoilSightFieldSoil = (soilSightProjectId: string | null, fieldId: string | null, silverServiceVersion: string | null) => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery<SoilSightFieldSoil>({
    queryKey: [GET_SOIL_SIGHT_FIELD_SOIL, soilSightProjectId, fieldId, silverServiceVersion],
    queryFn: () => getSoilSightFieldSoil(soilSightProjectId ?? ""),
    staleTime: Infinity, // one field on one model version always reports the same starting soil
    enabled: isAuthenticated && !!soilSightProjectId && !!fieldId,
  });
};
